export class AnalyticReport {
  username: string;
  uri: string;
  deviceType: string;
  screenHeight: number;
  screenWidth: number;
  timestamp: number;
}
